import { api } from "@/lib/api";

// §98 Shared sales inbox: campaign replies to sales@mynextbigmove.co, answered as sales@ (admin team only).
const B = "/admin/shared-inbox";
export const siThreads = (params) => api.get(`${B}/threads`, { params }).then((r) => r.data);
export const siThread = (id) => api.get(`${B}/threads/${encodeURIComponent(id)}`).then((r) => r.data);
export const siRead = (id) => api.post(`${B}/threads/${encodeURIComponent(id)}/read`).then((r) => r.data);
export const siReply = (id, body) => api.post(`${B}/threads/${encodeURIComponent(id)}/reply`, { body }).then((r) => r.data);
export const siSuggest = (id, tone) => api.post(`${B}/threads/${encodeURIComponent(id)}/suggest`, { tone }).then((r) => r.data);
export const siErr = (e) => (e?.response?.status === 404 ? "The shared sales inbox isn't live on the server yet (spec §98)." : e?.response?.data?.detail || "Something went wrong. Please try again.");
